import { render } from "./ScrollToReturns.vue?vue&type=template&id=12d61393"
import script from "./ScrollToReturns.vue?vue&type=script&lang=js"
export * from "./ScrollToReturns.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ScrollToReturns.vue?vue&type=style&index=0&id=12d61393&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__